import React from 'react';
import PropTypes from 'prop-types';
import { Layout } from 'antd';
import { StyledLayoutAdmin } from './style';
import SiderAdmin from '../Sider';
const { Content, Footer } = Layout;

function LayoutAdmin(props) {
  const { children } = props;

  return (
    <StyledLayoutAdmin style={{ minHeight: '100vh' }}>
      <SiderAdmin />
      <Layout className="site-layout">
        <Content style={{ margin: '0 16px' }}>{children}</Content>
        <Footer style={{ textAlign: 'center' }}>Powered by WeJelly.</Footer>
      </Layout>
    </StyledLayoutAdmin>
  );
}

LayoutAdmin.propTypes = {
  children: PropTypes.any,
};

export default LayoutAdmin;
